import * as angular from 'angular';

let nextId = Date.now();

interface ISelectListScope extends angular.IScope {
    uid: string;
    heightOffset: number;
    position: string;
}

class SelectListDirective implements angular.IDirective {
    readonly replace = true;
    readonly transclude = true;
    readonly restrict = 'E';
    readonly scope = {
        label: '@',
        position: '=',
        alignment: '=',
        heightOffset: '=?'
    };

    readonly template = `
        <div class="fc-select-list">
            <fc-button class="fc-select-list-toggle" invariant="toggle" data-toggle="{{ uid }}">
                <span class="fc-select-list-label">{{ label || 'Select' }}</span>
            </fc-button>
            <div
                id="{{ uid }}"
                class="fc-select-list-items dropdown-pane"
                ng-style="{ 'max-height': 'calc(100% - ' + heightOffset + 'px)' }"
                data-dropdown
                data-auto-focus="true"
                data-close-on-click="true"
                data-position="{{ position || 'auto' }}"
                data-align="{{ alignment || 'left' }}"
                data-options="position:{{ position || 'auto' }}; align:{{ alignment || 'left' }};"
            >
                <ul ng-transclude></ul>
            </div>
        </div>
    `;

    readonly link: angular.IDirectiveLinkFn;

    constructor() {
        this.link = this._link.bind(this);
    }

    private _link(scope: ISelectListScope, element: JQuery): void {
        scope.uid = `fc-select-list__${nextId++}`;
        scope.heightOffset = scope.heightOffset === undefined || scope.heightOffset === null ? 0 : scope.heightOffset;
        
        // Little hack to maintain the state of the button toggling when the dropdown closes
        const button = element.find('.fc-select-list-toggle');
        const dropdown = element.find('.fc-select-list-items');

        dropdown.on('hide.zf.dropdown', () => {
            button.removeClass('fc-button-toggled');
        });

        scope.$on('$destroy', () => {
            dropdown.off();
        });

        element.ready(() => {  
            scope.$watch('position', (newValue, oldValue) => {
                const button = element.find('.fc-select-list-toggle');
                const dropdown = element.find('.fc-select-list-items');

                removeClassStartingWith(dropdown, 'has-position-');
                removeClassStartingWith(dropdown, 'has-alignment-');
            });
        });

        var removeClassStartingWith = (element: JQuery, className: string): void => {
            const regEx = new RegExp(`\\b${className}\\S+`, 'g');
            
            element.removeClass((index, className) => {
                className = (className.match (regEx) || []).join(' ');
                return className;
            });
        }
    }
}

const SelectListDirectiveFactory: angular.IDirectiveFactory = () => new SelectListDirective();

export { SelectListDirectiveFactory };
